import { render } from "./DayViewWorkAreaGridGroupBarItem.vue?vue&type=template&id=49e24256"
import script from "./DayViewWorkAreaGridGroupBarItem.vue?vue&type=script&lang=ts"
export * from "./DayViewWorkAreaGridGroupBarItem.vue?vue&type=script&lang=ts"
script.render = render

export default script